export default "__VITE_ASSET__BhqGhw94__"